import { BaseMetadata } from 'types';
import type { DocumentContact } from '@mercator-gcp/types/backend/DocumentContact';

// TODO: Move this to the API

const isValidContactsArray = (data: unknown): data is DocumentContact[] => {
  if (!Array.isArray(data)) return false;

  return data.every(
    (item) =>
      typeof item === 'object' &&
      item !== null &&
      ('type' in item ||
        'name' in item ||
        'phone' in item ||
        'company' in item ||
        'email' in item),
  );
};

/**
 * Handles all contact record renaming or other transformations that may be necessary.
 *
 * @param contact The contact to transform.
 * @returns The transformed contact.
 */
export const parseContactRecord = (contact: DocumentContact) => {
  const newContact = { ...contact };
  if (newContact.type === 'project') {
    newContact.type = 'Business Operator';
  }

  return newContact;
};

export const parseRelatedContactsIntoList = (
  contacts: BaseMetadata['relatedcontacts'],
): DocumentContact[] => {
  if (!contacts) return [];

  // A fallback for when the relatedcontacts is a string - this should never happen
  if (typeof contacts === 'string' || contacts instanceof String) {
    try {
      const jsonString = contacts
        .replace(/'/g, '"')
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null');

      return JSON.parse(jsonString);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error parsing related contacts:', e);

      return [];
    }
  }

  const parsedContacts = contacts.map((contact) => parseContactRecord(contact));
  if (isValidContactsArray(parsedContacts)) {
    return parsedContacts;
  }

  return [];
};
